import { BaseApi } from 'api/base.api'

// Interface
import {
  IAboutUsWorkCultureApi,
  IAboutUsWorkCultureApiRequest,
  IAboutUsWorkCultureApiGetAllAttrs,
  IAboutUsWorkCultureApiGetAllResponse,
  IAboutUsWorkCultureApiGetAttrs,
  IAboutUsWorkCultureApiGetResponse,
  IAboutUsWorkCultureApiSaveAttrs,
  IAboutUsWorkCultureApiSaveResponse,
  IAboutUsWorkCultureApiDeleteAttrs,
  IAboutUsWorkCultureApiDeleteResponse,
} from 'interfaces/back-office/content-management/about-us/work-culture/about-us-work-culture-api.interface'

// Constant
import { ApiConstant } from 'constant'
import {
  ABOUT_US_WORK_CULTURES,
  ABOUT_US_WORK_CULTURE,
} from 'constant/content-management/about-us/about-us-work-culture.constant'

// Utils
import { commonUtils_delay } from 'utils/common/common.utils'

export class AboutUsWorkCultureApi extends BaseApi<IAboutUsWorkCultureApi> implements IAboutUsWorkCultureApiRequest {
  readonly url = ApiConstant.CONTENT_ABOUT_US_WORK_CULTURE_URL

  /**
   * @description Get home banners
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsWorkCultureApiGetAllAttrs} payload
   *
   * @return {Promise<IAboutUsWorkCultureApiGetAllResponse>} Promise<IAboutUsWorkCultureApiGetAllResponse>
   */
  async aboutUsWorkCulture_getAboutUsWorkCultures(
    payload: IAboutUsWorkCultureApiGetAllAttrs,
  ): Promise<IAboutUsWorkCultureApiGetAllResponse> {
    try {
      // const response = await this.POST('/', payload.body, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(ABOUT_US_WORK_CULTURES)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsWorkCultureApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsWorkCultureApiGetResponse>} Promise<IAboutUsWorkCultureApiGetResponse>
   */
  async aboutUsWorkCulture_getAboutUsWorkCulture(
    payload: IAboutUsWorkCultureApiGetAttrs,
  ): Promise<IAboutUsWorkCultureApiGetResponse> {
    try {
      // const response = await this.POST('/', payload.body, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(ABOUT_US_WORK_CULTURE)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsWorkCultureApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsWorkCultureApiSaveResponse>} Promise<IAboutUsWorkCultureApiSaveResponse>
   */
  async aboutUsWorkCulture_saveAboutUsWorkCulture(
    payload: IAboutUsWorkCultureApiSaveAttrs,
  ): Promise<IAboutUsWorkCultureApiSaveResponse> {
    try {
      // const requestPayload: IBaseApiRequestPayload = {
      //   method: payload.params?.id ? 'PUT' : 'POST',
      //   url: payload.params?.id ? `${this.url}/${payload.params.id}` : this.url,
      // }
      // const response = await this[requestPayload.method](requestPayload.url, {}, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(ABOUT_US_WORK_CULTURE)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsWorkCultureApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsWorkCultureApiSaveResponse>} Promise<IAboutUsWorkCultureApiSaveResponse>
   */
  async aboutUsWorkCulture_deleteAboutUsWorkCulture(
    payload: IAboutUsWorkCultureApiDeleteAttrs,
  ): Promise<IAboutUsWorkCultureApiDeleteResponse> {
    try {
      // const requestPayload: IBaseApiRequestPayload = {
      //   method: payload.params?.id ? 'PUT' : 'POST',
      //   url: payload.params?.id ? `${this.url}/${payload.params.id}` : this.url,
      // }
      // const response = await this[requestPayload.method](requestPayload.url, {}, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(ABOUT_US_WORK_CULTURES)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
